import styled, { css } from 'styled-components';
import { color, fontWeight, radius, shadow, spacing } from '../../theme';

export const StyledRadioButtonIcon = styled.div`
  width: ${spacing('lg')};
  height: ${spacing('lg')};
  border-radius: ${radius('full')};
  border: 2px solid ${color('midnight_200')};
  position: relative;
  transition: 0.3s;
  flex-shrink: 0;

  &::after {
    content: '';
    width: ${spacing('sm')};
    height: ${spacing('sm')};
    border-radius: ${radius('full')};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${color('midnight_200')};
    opacity: 0;
    transition: 0.3s;
  }
`;

export const StyledRadioButton = styled.div<{ isCard?: boolean }>`
  display: flex;
  align-items: center;

  input[type='radio'] {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;

    &:checked + label ${StyledRadioButtonIcon} {
      background-color: ${color('midnight_800')};
      border-color: ${color('midnight_800')};

      &::after {
        opacity: 1;
      }
    }

    &:hover + label ${StyledRadioButtonIcon} {
      border-color: ${color('midnight_400')};
    }

    &:checked:hover + label ${StyledRadioButtonIcon} {
      border-color: ${color('midnight_600')};
      background-color: ${color('midnight_600')};
    }

    &:focus + label ${StyledRadioButtonIcon} {
      outline: 0;
      border-color: ${color('midnight_850')};
      box-shadow: 0 0 0 4px ${color('midnight_150')};
    }

    &[disabled] {
      pointer-events: none;

      & + label {
        color: ${color('text_disabled')};
        pointer-events: none;

        ${StyledRadioButtonIcon} {
          border-color: ${color('text-disabled')};
          background-color: ${color('midnight_150')};
        }
      }

      &:checked + label ${StyledRadioButtonIcon} {
        border-color: ${color('midnight_150')};
        background-color: ${color('midnight_150')};
      }
    }
  }

  ${({ isCard }) =>
    isCard &&
    css`
      input[type='radio'] {
        & + label {
          border: 1px solid ${color('midnight_200')};
          border-radius: ${radius('md')};
          padding: ${spacing('md')};
          box-shadow: ${shadow('md')};
          cursor: pointer;

          font-weight: ${fontWeight('extraBold')};
        }

        &:checked + label {
          background: ${color('active')};
          border-color: ${color('active')};
        }
      }
    `}
`;

export const StyledRadioButtonLabel = styled.label<{
  isLabelReversed?: boolean;
}>`
  display: flex;
  align-items: center;
  line-height: 1;
  vertical-align: text-bottom;
  gap: ${spacing('xs')};

  ${({ isLabelReversed }) =>
    isLabelReversed &&
    css`
      flex-direction: row-reverse;
    `}
`;
